import { render, staticRenderFns } from "./User-childs.vue?vue&type=template&id=1d4388ee"
import script from "./User-childs.vue?vue&type=script&lang=js"
export * from "./User-childs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports